import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_component_Loading, {
    title: _ctx.loadingTitleText,
    description: _ctx.loadingDescription || undefined,
    fullscreen: ""
  }, null, 8, ["title", "description"]))
}